import React from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import { formatEventDate } from "../utility/DateUtils"
import CategorySubheader from "./CategorySubheader"
import ItemCard from "../items/components/ItemCard"
import { isJaguar } from "../utility/UserUtils"
import Cookies from "universal-cookie"
import Breadcrumbs from "../layouts/breadcrumbs/Breadcrumbs";
import SuperFilter from "../layouts/superfilter/SuperFilter";
import { isArray } from "jquery";
import AddNewItemButton from "@/layouts/partials/headers/AddNewItemButton";
import ManageInventoryButton from "@/layouts/partials/headers/ManageInventoryButton";


class CategoryDashboard extends React.Component {
  constructor(props) {
    const cookies = new Cookies();
    const showPrivate = cookies.get("show_internal_items");
    super(props);
    this.state = {
      items: props.items,
      showPrivate: showPrivate == "true",
      superFilters: [],
    }
    this.toggleShowPrivate = this.toggleShowPrivate.bind(this);
  }

  renderItems() {
    let { items, showPrivate } = this.state;
    const { user } = this.props;
    if(!isJaguar(user)){
      items = items.filter(a=> a.public);
    }
    items = this.getFilteredItems(items);
    items = items.filter(item => item.owned > 0);
    return items.filter(item=> !item.variant_of_id).map(item => (
      <ItemCard key={`item-card-${item.id}`} item={item} user={user}/>
    ))
  }

  getFilteredItems(items) {
    const { superFilters } = this.state;
    let filteredItems = items
    superFilters.forEach(filterObject =>{
      switch(filterObject.filterID){
        case "subcategory":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            console.log(filterObject.filterValue)
            filteredItems = filteredItems.filter(item => filterObject.filterValue.includes(item.category?.name));
          }
          break;
        case "search":
          if(filterObject.filterValue){
            filteredItems = filteredItems.filter(item => {
              const searchInName = item.name.toLowerCase().includes(filterObject.filterValue.toLowerCase())
              const searchInCategory = (item?.category?.name||"").toLowerCase().includes(filterObject.filterValue.toLowerCase())
              const searchInGroup = (item?.category?.group_name||"").toLowerCase().includes(filterObject.filterValue.toLowerCase())
              return searchInName || searchInCategory || searchInGroup
            });
          }
          break;
        default:
          break;
      }
    })
    return filteredItems
  }

  toggleShowPrivate(){
    const cookies = new Cookies();
    const showPrivate = cookies.set("show_internal_items", !this.state.showPrivate);
    this.setState({
      showPrivate: !this.state.showPrivate
    })
  }

  getBreadcrumbLinks() {
    const { renter, category, group } = this.props;
    let links = [
      {
        name: `Jaguar Inventory`,
        url: `/`
      }
    ]

    if (group) {
      links.push({
        name: group,
        url: `/category/${group}`
      })
      if(category) {
        links.push({
          name: category,
          url: `/${group}/${category}`
        })
      }
    }

    return links
  }

  renderSuperFilters() {

    return (
      <SuperFilter
        urlLock={true}
        search={true}
        disableLabel={true}
        onChange={(filters) => {
          this.setState({superFilters: filters});
        }}
        id={`category-dashboard-list-superfilter`}
        lockable
        filters={[
          {
            outerClassName: "sg-super-filter-select-field-option-spacing",
            id: "subcategory",
            type:"multiselect",
            options: 
              this.props.categories.map(category => {
                return {value: category.name, id: category.name, label: category.name}
              }).sort((a,b) => (a.label < b.label ? -1 : 1))
            ,
            placeholder: "Subcategory",
            name: "Subcategory"
          },
          {
            id: "search",
            type:"search",
            options: [],
            outerClassName: "sg-super-filter-search-field-option-spacing",
            placeholder: "Search",
            name: "Search"
          }
        ]}
      />
    )
  }



  render() {
    const { group, user, renter } = this.props;
    return (
      <PublicCatalogLayout
        currentPage={`group-${group}`}
        {...this.props}
        currentGroup={group}
        className="category-dashboard"
      >    
        <div className="row">
          <div className="col-xs-12">
            <h1 class="catalog-h1">
              {this.props.category ? this.props.category : this.props.group}
              <div
                className="catalog-h1-float-right"
              >
                <AddNewItemButton loadItems={true} user={user} renter={renter} /> 
                <ManageInventoryButton user={user} renter={renter} />
              </div>
            </h1>
          </div>
        </div>

        {this.renderSuperFilters()}
        {this.renderItems()}
      </PublicCatalogLayout>
    );
  }
}

CategoryDashboard.propTypes = {
  category: PropTypes.object.optional,
  categories: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
};

export default CategoryDashboard;
